import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import School from '@/pages/projects/Project/School';
import Location from '@/pages/projects/Project/Location';
import useDialogLauncher from '@/dialogs-routable/_hooks/useDialogLauncher';
import { DialogManager } from '@/dialogs_new/DialogManager';
import Image from './Image';
import { useConnect } from '@lore/query-connect';
import ProjectBookmark from '@/components/ProjectBookmark';
import { useUser } from '@lore/auth';
import { StarIcon } from '@heroicons/react/24/solid';

Project.propTypes = {
  project: PropTypes.object.isRequired,
  className: PropTypes.string,
};

export default function Project(props) {
  const { project, className } = props;

  const activity = useConnect('tag.byId', {
    id: project.data.activityId
  });

  const currentUser = useUser();
  const launch = useDialogLauncher();

  function onClick() {
    launch(DialogManager.ProjectPast.Config(project.id));
  }

  return (
    <div className={classNames(
      'flex flex-col bg-white',
      'shadow-cs-flat rounded-cs-10',
      '-m-0.5 border-2 border-cs-gray-100',
      'relative overflow-hidden',
      'hover:bg-cs-orange-50 cursor-pointer',
      className
    )} data-testid="project-card">
      <div className="absolute z-10 top-6 right-6">
        <ProjectBookmark
          project={project}
          user={currentUser}
        />
      </div>
      {/*<Link to={`/projects/${project.id}`} className="absolute w-full h-full" />*/}
      <div className="flex flex-col py-4 px-4 space-y-2" onClick={onClick}>
        {/*<Header project={project}/>*/}
        <Image project={project} />
        <div className="text-lg text-cs-gray-900 font-semibold line-clamp-5x">
          {project.data.title || activity.data.name}
        </div>
        <div className="flex flex-col sm:flex-row items-start justify-between">
          <div className="flex flex-1 flex-wrap gap-x-4 gap-y-2 mb-2 sm:mb-0">
            {/*<Date project={project}/>*/}
            {/*<Time project={project} />*/}
            {/*<Creator project={project} />*/}
            <School project={project} />
            {/*<Images project={project} />*/}
            {/*<Documents project={project} />*/}
            {/*<Testimonials project={project} />*/}
            {/*<Distance project={project} />*/}
            <Location project={project} />
            {project.data.featuredAt && <div className="text-sm text-cs-gray-500 flex items-center gap-1"><StarIcon className="text-cs-yellow-600 size-6" /> <span>Featured</span></div>}
          </div>
          {/*<Distance project={project} />*/}
        </div>
      </div>
      {/*<div className={classNames(*/}
      {/*  'w-full py-4 px-4',*/}
      {/*  'bg-cs-gray-50',*/}
      {/*  '-mt-px border-t border-cs-gray-100',*/}
      {/*)}>*/}
      {/*  <Collaborators project={project} />*/}
      {/*</div>*/}
    </div>
  );
}
